import ownerDocument from '@mui/utils/ownerDocument';
export default ownerDocument;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/ownerDocument.js
// module id = 199
// module chunks = 25